export default __webpack_public_path__ + "static/media/cashGif.325a7bb6.gif";